<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_8"></a><a id="frontmatter1"></a>ACKNOWLEDGMENTS</h2>
<p class="noindent">This book would not have been possible without the generous assistance of the expert sailors who shared their time and experiences to help bring these fifty great sailing venues to life. To these men and women, I offer the most heartfelt thanks. I would especially like to thank Sue Maffei Plowden (Suma, to her friends), who offered much advice and countless introductions to her vast circle of sailing pals. I also want to acknowledge the fine efforts of my editors Jennifer Levesque, Dervla Kelly, and Kate Norment, designer Paul Wagner, and copyeditors Sylvia Karchmar and Elizabeth Norment, who helped bring the book into being despite a deadline baby (Jennifer’s first, Veronica Rose) and a very late manuscript delivery. These folks do a wonderful job; as I’m fond of saying, if the words are half as good as the aesthetics of the book itself, it won’t be a terrible read! Thanks should also go to my agent Stephanie Kip Rostan, who talked me off the ledge on more than one occasion (due to said late manuscript delivery). Last, I’d like to thank my parents, who didn’t insist that I take sailing lessons, but encouraged me to try new things and constantly expand my horizons . . . and my wife, Deidre, and daughters, Cassidy Rose and Annabel Blossom, who have shown such tremendous love, patience, and support as I wrestle against deadline after deadline.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter1.vue?01fd4da8